"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripHtmlTags = exports.queryParameterSet = exports.getQueryParameters = void 0;
function getQueryParameters() {
    return new Proxy(new URLSearchParams(window.location.search), {
        get: function (searchParams, prop) { return searchParams.get(prop); }
    });
}
exports.getQueryParameters = getQueryParameters;
function queryParameterSet(key) {
    var params = getQueryParameters();
    return !!params[key];
}
exports.queryParameterSet = queryParameterSet;
function stripHtmlTags(input) {
    var tempDivTag = document.createElement("div");
    tempDivTag.innerHTML = input;
    return tempDivTag.textContent || tempDivTag.innerText || "";
}
exports.stripHtmlTags = stripHtmlTags;
